import {
  Input as ChakraInput,
  InputGroup,
  InputLeftElement,
  InputRightElement,
} from '@chakra-ui/react';
import React from 'react';

import { colors } from 'packages/common-frontend/constants';

/**
 *  TODO: This file content should be consolidated  with FormField.tsx
 *
 *  NOTE: We should create onKeyEvent which restricts any non-digit input for Currency and Percentage Input
 */

// ===== Helpers =====
const emptyInputPostfix = (
  <InputLeftElement pointerEvents="none" color="gray.300" fontSize="1.2em" />
);
const emptyInputPrefix = (
  <InputLeftElement pointerEvents="none" color="gray.300" fontSize="1.2em" />
);

/**
 * Generic Input
 * This is generic input element, but it can introduce offset spacing properly, when combined with other elements
 */
export const Input = ({
  postfixSpace,
  prefixSpace,
  ...props
}: {
  postfixSpace?: boolean;
  prefixSpace?: boolean;
}) => {
  return (
    <InputGroup mb="17px">
      {prefixSpace && emptyInputPrefix}
      <ChakraInput
        focusBorderColor={colors.fundingRequest.sliderGreen}
        {...props}
      />
      {postfixSpace && emptyInputPostfix}
    </InputGroup>
  );
};
Input.defaultProps = {
  postfixSpace: false,
  prefixSpace: false,
};

/**
 * Currency Input
 * Have to use Chakra's Input within InputGroup, or style will break with Input...Element tags
 */
export const CurrencyInput = ({
  postfixSpace,
  ...props
}: {
  postfixSpace?: boolean;
}) => {
  return (
    <InputGroup mb="17px">
      <InputLeftElement pointerEvents="none" color="gray.300" fontSize="1.2em">
        $
      </InputLeftElement>
      <ChakraInput
        focusBorderColor={colors.fundingRequest.sliderGreen}
        {...props}
      />
      {postfixSpace && emptyInputPostfix}
    </InputGroup>
  );
};
CurrencyInput.defaultProps = {
  postfixSpace: false,
};

/**
 * Percentage Input
 * Have to use Chakra's Input within InputGroup, or style will break with Input...Element tags
 */
export const PercentageInput = ({
  prefixSpace,
  ...props
}: {
  prefixSpace?: boolean;
}) => {
  return (
    <InputGroup mb="17px">
      {prefixSpace && emptyInputPrefix}
      <ChakraInput
        focusBorderColor={colors.fundingRequest.sliderGreen}
        {...props}
      />
      <InputRightElement pointerEvents="none" color="gray.300" fontSize="1.2em">
        %
      </InputRightElement>
    </InputGroup>
  );
};
PercentageInput.defaultProps = {
  prefixSpace: false,
};
